import { cn } from '../../../lib/utils'
import { Skeleton } from '../skeleton'

interface BadgeSkeletonProps {
  className?: string
}

export const BadgeSkeleton = ({ className }: BadgeSkeletonProps): React.ReactElement => {
  return <Skeleton className={cn('h-[30px] w-[100px] bg-primary-gray', className)} />
}
